import { BACKEND_BASE_URL, ICashDeviceManagerWrapper, IResponseError } from "@/services";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";
import { IDepositService } from "@/services/backend/deposit/deposit.types";

export class DepositService implements IDepositService {
  async prmTransactions(
    cashDeviceManagerWrapper: ICashDeviceManagerWrapper
  ): Promise<boolean | undefined> {
    const { error } = await handleResponse<Promise<void>, IResponseError>(
      Vue.$axios.post(
        `${BACKEND_BASE_URL}/api/smartcash/v1/devices/deposit`,
        cashDeviceManagerWrapper
      )
    );
    if (error) {
      return false;
    } else {
      return true;
    }
  }
}
